var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExam = function SvgExam(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2672 10.3832L14.4672 10.7332C13.5339 10.7332 12.7172 10.1498 12.7172 9.2165L12.3672 6.4165H12.4839L17.2672 10.3832Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2004 20.6499C18.3171 21.5832 17.6171 22.3999 16.8004 22.3999L8.0504 23.3332H7.93373H7.7004C6.76706 23.4499 5.9504 22.7499 5.9504 21.9332L4.66706 8.86654C4.5504 7.9332 5.2504 7.11654 6.06706 7.11654L12.2504 6.5332H12.3671L12.6004 9.21654C12.6004 9.44987 12.7171 9.6832 12.8337 9.79987C12.9504 9.91654 13.0671 10.1499 13.1837 10.2665C13.5337 10.6165 14.0004 10.7332 14.4671 10.7332H14.7004H14.8171L17.1504 10.4999L18.2004 20.6499Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9669 10.3832L17.3836 10.4999H17.2669L15.1669 10.7332C15.0503 10.7332 14.9336 10.7332 14.9336 10.7332C14.1169 10.7332 13.5336 10.0332 13.4169 9.3332L13.1836 7.11654V6.99987V6.5332H13.3003L17.9669 10.3832Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2006 20.6499C18.3173 21.5832 17.6173 22.3999 16.8006 22.3999L8.05059 23.3332C7.35059 23.2165 6.65059 22.6332 6.65059 21.9332L5.36726 8.86654C5.25059 7.9332 5.95059 7.11654 6.76726 7.11654L12.3673 6.5332H12.4839H12.8339H12.9506V6.99987V7.11654L13.1839 9.21654C13.3006 10.0332 13.8839 10.6165 14.7006 10.6165C14.8173 10.6165 14.9339 10.6165 14.9339 10.6165L17.2673 10.4999L18.2006 20.6499Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 9.68317H17.8501C16.8001 9.68317 15.9834 8.8665 15.9834 7.8165V4.6665L16.1001 4.78317L21.0001 9.68317Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 9.68317V21.4665C21.0005 22.5165 20.1838 23.3332 19.1338 23.3332H8.75046C7.70046 23.3332 6.88379 22.5165 6.88379 21.4665V6.53317C6.88379 5.48317 7.70046 4.6665 8.75046 4.6665H15.8671H15.9838V7.8165C15.9838 8.8665 16.8005 9.68317 17.8505 9.68317H21.0005Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 9.68317V21.4665C21.0007 22.5165 20.184 23.3332 19.134 23.3332H9.68405C8.63405 23.3332 7.81738 22.5165 7.81738 21.4665V6.53317C7.81738 5.48317 8.63405 4.6665 9.68405 4.6665H15.8674H15.984V7.8165C15.984 8.8665 16.8007 9.68317 17.8507 9.68317H21.0007Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9667 12.8332H11.0833C10.7333 12.8332 10.5 12.5998 10.5 12.2498C10.5 11.8998 10.7333 11.6665 11.0833 11.6665H17.9667C18.3167 11.6665 18.55 11.8998 18.55 12.2498C18.55 12.5998 18.2 12.8332 17.9667 12.8332Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9667 16.0998H11.0833C10.7333 16.0998 10.5 15.8664 10.5 15.5164C10.5 15.1664 10.7333 14.9331 11.0833 14.9331H17.9667C18.3167 14.9331 18.55 15.1664 18.55 15.5164C18.55 15.8664 18.2 16.0998 17.9667 16.0998Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9333 19.3664H11.0833C10.7333 19.3664 10.5 19.133 10.5 18.783C10.5 18.433 10.7333 18.1997 11.0833 18.1997H14.9333C15.2833 18.1997 15.5167 18.433 15.5167 18.783C15.5167 19.133 15.2833 19.3664 14.9333 19.3664Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8833 11.2001L20.7666 11.5501L23.2166 12.2501L23.3333 11.9001C23.5666 11.2001 23.2166 10.5001 22.5166 10.2667C21.8166 10.1501 21.1166 10.5001 20.8833 11.2001Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1335 20.8834L17.9668 20.5334L20.5335 12.3667L21.7001 12.7167L19.1335 20.8834Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4171 21.2335L19.1338 20.8835L21.7005 12.7168L22.8671 13.0668L20.4171 21.2335Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2165 12.2503L20.7665 11.4336L20.5332 12.3669L21.6999 12.7169L22.8665 13.0669L23.2165 12.2503Z",
    fill: "#444447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1335 20.8832L17.9668 20.5332L18.2001 21.8165L19.3668 22.2832L20.4168 21.2332L19.1335 20.8832Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3669 22.2836L18.2002 21.8169L18.4335 23.2169L19.3669 22.2836Z",
    fill: "url(#paint14_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -1,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.4329,
    y1: 10.7328,
    x2: 14.5494,
    y2: 8.70783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.954,
    y1: 13.8217,
    x2: 8.46748,
    y2: 15.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17.751,
    y1: 5.24768,
    x2: 8.8974,
    y2: 17.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 19.0849,
    y1: 7.3431,
    x2: 6.54128,
    y2: 20.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 20.0134,
    y1: 4.76379,
    x2: 17.5319,
    y2: 8.79604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 19.101,
    y1: 14.239,
    x2: 0.49699,
    y2: 13.5812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 10.7849,
    y1: -3.31525,
    x2: 15.9406,
    y2: 23.5176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 14.5288,
    y1: 11.7609,
    x2: 14.3527,
    y2: 14.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 14.4945,
    y1: 15.2961,
    x2: 14.6002,
    y2: 18.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 13.0048,
    y1: 18.5109,
    x2: 13.0401,
    y2: 20.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 22.7487,
    y1: 10.2851,
    x2: 21.5742,
    y2: 12.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9129,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 20.116,
    y1: 12.3635,
    x2: 19.7275,
    y2: 18.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 22.3377,
    y1: 17.2579,
    x2: 20.4925,
    y2: 16.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 17.9635,
    y1: 21.365,
    x2: 20.3704,
    y2: 21.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1975,
    stopColor: "#FDD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 19.0073,
    y1: 21.2236,
    x2: 18.6613,
    y2: 22.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 18.6667,
    fill: "white",
    transform: "translate(4.66699 4.6665)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Exam.d7180066.svg";
export { ForwardRef as ReactComponent };